module.exports = __webpack_public_path__ + "img/asset-1.85af10bb.png";